module.exports = __webpack_public_path__ + "static/media/china-flag.52180ea3.png";